import React, { useState } from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import styles from "styles/faq.module.scss"
import { graphql } from "gatsby"

const FaqPage = ({ data }) => {
  const [active, setActive] = useState()

  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter } = markdownRemark
  return (
    <Layout active="faq" bottomInfo={false}>
      <SEO title="Frequently Asked Questions" />
      <section>
        <div className="bg-snow-100 flex items-center justify-center relative">
          <div className="mx-auto w-11/12 md:w-10/12 xl:w-8/12 text-center">
            <div className="h-32 w-full"></div>
            <h1 className="text-grey-100 font-bold text-5xl w-10/12 mx-auto">
              Frequently Asked Questions
            </h1>
            <h2 className="text-grey-200 tracking-xs text-sm mt-4 md:w-6/12 mx-auto">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Justo
              arcu viverra nunc orci, ultrices.
            </h2>
            <div className="h-32 w-full"></div>
          </div>
        </div>
      </section>

      <div
        className={`w-10/12 lg:w-9/12 xl:w-8/12 mx-auto relative ${styles.search_container}`}
      >
        <div className="absolute top-0 pl-6 flex items-center h-full">
          <img
            src={require("images/search-icon.svg")}
            className="w-5"
            alt="search icon"
          />
        </div>
        <input
          className={styles.search_input}
          placeholder="What are you looking for?"
        />
      </div>

      <section>
        <div className="my-24 w-10/12 lg:w-9/12 xl:w-8/12 mx-auto grid gap-5">
          {frontmatter.questions.map((faq, i) => (
            <div
              role="button"
              tabIndex={0}
              className="w-full bg-snow-100 rounded-sm py-8 px-6 cursor-pointer"
              onClick={() => setActive(i)}
              onKeyDown={() => setActive(i)}
            >
              <div className="flex items-center justify-between">
                <p className="font-medium text-2xl">{faq.question.title}</p>
                <svg
                  width="12"
                  height="24"
                  viewBox="0 0 12 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`transform duration-500 ${
                    active === i ? "rotate-90" : " rotate-0"
                  }`}
                >
                  <path
                    d="M0 24L12 12L-1.04907e-06 0"
                    fill={active === i ? "#52BD95" : "#7C8087"}
                  />
                </svg>
              </div>
              <div
                className={`${
                  active === i
                    ? "h-40 overflow-auto mt-10"
                    : "h-0 overflow-hidden"
                }`}
              >
                <hr className="border-t border-grey-300" />
                <div>
                  <p
                    className="text-base text-grey-200 mt-5"
                    style={{ lineHeight: "30px" }}
                  >
                    {faq.question.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  )
}

export default FaqPage

export const pageQuery = graphql`
  query {
    markdownRemark {
      frontmatter {
        slug
        title
        questions {
          question {
            content
            title
          }
        }
      }
    }
  }
`
